module.exports = __webpack_public_path__ + "img/bl_header_dark.6def18a6.webp";